module.exports = {"522323001":"盘水街道","522323002":"南湖街道","522323101":"龙吟镇","522323103":"江西坡镇","522323105":"地瓜镇","522323107":"楼下镇","522323108":"兴中镇","522323109":"青山镇","522323110":"罗汉镇","522323111":"新店镇","522323200":"白沙乡","522323201":"高棉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522323.json
// module id = 2504
// module chunks = 0